import { render } from "./ContractRegisterEdit.vue?vue&type=template&id=c119c338&scoped=true&ts=true"
import script from "./ContractRegisterEdit.vue?vue&type=script&lang=ts"
export * from "./ContractRegisterEdit.vue?vue&type=script&lang=ts"

import "./ContractRegisterEdit.vue?vue&type=style&index=0&id=c119c338&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c119c338"]])

export default __exports__